import { useState } from 'react';
import { get } from '../helpers/apiHelper';
import Swal from 'sweetalert2';

export const useBusinessAnalyzer = (userId, navigate) => {
    const [analyzingBusiness, setAnalyzingBusiness] = useState(false);

    const analyzeBusiness = async () => {
        if (!userId) {
            Swal.fire({
                title: 'Error',
                text: 'No se pudo identificar el usuario',
                icon: 'error'
            });
            return;
        }

        try {
            setAnalyzingBusiness(true);
            const response = await get(`agents/optimized/business-recommendations/${userId}`);

            if (response.success) {
                // Mostrar resultados en un modal o navegar a una página específica
                Swal.fire({
                    title: 'Análisis Completado',
                    html: `
            <div class="text-left">
              <h3 class="font-bold mb-3">Enfoque Principal: ${response.recommendations.primaryFocus.replace('_', ' ').toUpperCase()}</h3>
              <p class="mb-3"><strong>Confianza:</strong> ${(response.recommendations.confidence * 100).toFixed(0)}%</p>
              <p class="mb-3"><strong>Razón:</strong> ${response.recommendations.reasoning}</p>
              <div class="mt-4">
                <h4 class="font-semibold mb-2">Recomendaciones:</h4>
                <ul class="list-disc list-inside space-y-1">
                  ${response.recommendations.recommendations.slice(0, 3).map(rec => `<li>${rec}</li>`).join('')}
                </ul>
              </div>
            </div>
          `,
                    icon: 'success',
                    confirmButtonText: 'Ver Detalles Completos',
                    showCancelButton: true,
                    cancelButtonText: 'Cerrar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Aquí podrías navegar a una página de análisis detallado
                        navigate('/statistics/dashboard');
                    }
                });
            } else {
                throw new Error('No se pudo obtener el análisis');
            }
        } catch (error) {
            console.error('Error analizando el negocio:', error);
            Swal.fire({
                title: 'Error',
                text: 'No se pudo analizar el negocio. Intenta nuevamente.',
                icon: 'error'
            });
        } finally {
            setAnalyzingBusiness(false);
        }
    };

    return {
        analyzingBusiness,
        analyzeBusiness
    };
}; 